import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const adminAxios = axios.create({ baseURL: API, withCredentials: true });

export const formatDetail = (detail) => {
  if (detail == null) return "";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : "")).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};
